import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../Store/AuthContext";
// import APIDataFetchLoader from "../../Utils/APIDataFetchLoader";
import Breadcrumb from "../../Component/Breadcrumb";
import ServiceFAQSBox from "../../Component/ServiceCMPT/ServiceFAQSBox";
import "./ServiceDetails.css";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function ServiceDetails() {
  const { serviceslug } = useParams();
  const navigate = useNavigate();
  const { RendomTokenfetch } = useAuth();
  const [ServiceDetails, setServiceDetails] = useState([]);
  const [MultiFaqsdata, setMultiFaqsdata] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [ShowServiceData, setShowServiceData] = useState(true);
  // console.log(MultiFaqsdata);

  const FetchServiceData = useCallback(async () => {
    setLoading(true);
    try {
      await axios
        .get(
          `${WebsiteAPIurl}serviceDetailsAPI.php?serviceslug=${serviceslug}`,
          {
            headers: {
              Authorization: RendomTokenfetch,
            },
          }
        )
        .then((response) => {
          // console.log(response.data);
          if (response.data.status === "1") {
            setServiceDetails(response.data.servicedata);
            setMultiFaqsdata(response.data.multiFaqsdata);
            // setShowServiceData(true);
          } else {
            setServiceDetails([]);
            setMultiFaqsdata([]);
            // setShowServiceData(false);
          }
        });
    } catch (error) {
      console.error("API Error:", error);
      navigate("/page-not-found", { replace: true });
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, serviceslug, navigate]);

  useEffect(() => {
    FetchServiceData();
  }, [FetchServiceData, serviceslug]);

  if (loading) {
    // return <APIDataFetchLoader />;
  }

  return (
    <>
      <Helmet>
        <title>{ServiceDetails.meta_title}</title>
        <meta name="description" content={ServiceDetails.meta_description} />
        <meta name="keywords" content={ServiceDetails.meta_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <Breadcrumb
        pagename={ServiceDetails?.title || ""}
        mainpage={"services"}
      />

      <section className="service-single-content-wrapper section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-1"></div>
            <div className="col col-lg-10 col-md-10 service-st2-content">
              <div className="service-single-content">
                <div className="service-details">
                  <h2>{ServiceDetails?.title || ""}</h2>

                  {ServiceDetails.tagline && (
                    <h4 className="mt-3">{ServiceDetails?.tagline || ""}</h4>
                  )}

                  {ServiceDetails.sub_title && (
                    <span className="gt-box">
                      {ServiceDetails?.sub_title || ""}
                    </span>
                  )}

                  {ServiceDetails.banner_image && (
                    <div className="gt-details-thumb">
                      <img
                        src={ServiceDetails.banner_image}
                        alt={ServiceDetails.bannerimage_alt}
                        title={ServiceDetails.bannerimage_title}
                      />
                    </div>
                  )}

                  <div
                    className="gt-list-content mb-0"
                    dangerouslySetInnerHTML={{
                      __html: ServiceDetails.description,
                    }}
                  ></div>
                </div>
              </div>
            </div>

            <div className="col-lg-1"></div>
          </div>
        </div>
      </section>
      {MultiFaqsdata.length > 0 && (
        <section className="faq-content-wrapper faq-page section_bottom_padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-1"></div>
              <div className="col col-lg-9 col-md-8 faq-content">
                <h3> {ServiceDetails?.faq_title || ""}</h3>
                <div className="panel-group" id="accordion">
                  {MultiFaqsdata.map((valu, index) => (
                    <ServiceFAQSBox key={index} faqsData={valu} />
                  ))}

                  {/* <div className="panel panel-default">
                  <div className="panel-heading">
                    <a
                      data-toggle="collapse"
                      data-parent="#accordion"
                      href="#collapseOne"
                      aria-expanded="true"
                    >
                      1. What industries do you specialize in?{" "}
                    </a>
                  </div>
                  <div id="collapseOne" className="panel-collapse collapse in">
                    <div className="panel-body">
                      <p>
                        The question is not whether we will achieve the
                        identified results targets – the question is whether
                        your organisation will.
                      </p>
                      <p>
                        Achieving the desired results is guaranteed through the
                        mutual cooperation with our clients. We work closely
                        together with our clients to break down overarching
                        goals to the individual level, in order for all
                        employees to see how they contribute and thereby carry
                        responsibility.
                      </p>
                    </div>
                  </div>
                </div>
           */}
                </div>
              </div>
              <div className="col-lg-2"></div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
